/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerDetailDto } from '../../models/lexplus-benutzer-detail-dto';
import { LexplusCreateBenutzerDto } from '../../models/lexplus-create-benutzer-dto';

export interface BenutzerverwaltungControllerCreateV1$Params {
      body: LexplusCreateBenutzerDto
}

export function benutzerverwaltungControllerCreateV1(http: HttpClient, rootUrl: string, params: BenutzerverwaltungControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerDetailDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerDetailDto>;
    })
  );
}

benutzerverwaltungControllerCreateV1.PATH = '/v1/benutzerverwaltung';
